import React from "react";
import { makeStyles } from "@material-ui/core";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import AssessmentIcon from "@material-ui/icons/Assessment";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";

var SUGGESTIONS = [
  {
    text: "Which contracts are under performing to the prior frozen forecast?",
    icon: CompareArrowsIcon,
    color: "#7C3AED",
    bgColor: "#F5F3FF",
  },
  {
    text: "Which contracts are underperforming with respect to the budget?",
    icon: AssessmentIcon,
    color: "#2563EB",
    bgColor: "#EFF6FF",
  },
  {
    text: "Show me the revenue and gross margin trend for top 10 contracts by revenue.",
    icon: TrendingUpIcon,
    color: "#059669",
    bgColor: "#ECFDF5",
  },
  {
    text: "Which resources are underutilized in the forecast for the current year?",
    icon: TrendingUpIcon,
    color: "#0891B2",
    bgColor: "#ECFEFF",
  },
];

var useStyles = makeStyles(function () {
  return {
    "@keyframes fadeInUp": {
      from: { opacity: 0, transform: "translateY(10px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
    "@keyframes scaleIn": {
      from: { opacity: 0, transform: "scale(0.9)" },
      to: { opacity: 1, transform: "scale(1)" },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      padding: "40px 24px",
      textAlign: "center",
    },
    greeting: {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "28px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "4px",
      animation: "$fadeInUp 400ms ease-out both",
    },
    greetingName: {
      background: "linear-gradient(120deg, #1e3a5f 0%, #2563eb 60%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    subtitle: {
      fontFamily: "'IBM Plex Sans', sans-serif",
      fontSize: "15px",
      color: "#6B7280",
      lineHeight: 1.6,
      maxWidth: "460px",
      marginBottom: "36px",
      animation: "$fadeInUp 400ms ease-out 100ms both",
    },
    suggestLabel: {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "11px",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "1px",
      color: "#9CA3AF",
      marginBottom: "14px",
      animation: "$fadeInUp 400ms ease-out 200ms both",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
      maxWidth: "560px",
      width: "100%",
      "@media (max-width: 600px)": {
        gridTemplateColumns: "1fr",
      },
    },
    card: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderLeft: "3px solid transparent",
      borderRadius: "12px",
      padding: "16px",
      textAlign: "left",
      cursor: "pointer",
      position: "relative",
      transition: "all 200ms ease-out",
      animation: "$fadeInUp 300ms ease-out both",
      "&:hover": {
        borderColor: "#BFDBFE",
        borderLeftColor: "#BFDBFE",
        background: "#FAFBFF",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        transform: "translateY(-1px)",
      },
      "&:active": {
        transform: "translateY(0px)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      },
      "&::after": {
        content: '"→"',
        position: "absolute",
        right: "12px",
        bottom: "10px",
        fontSize: "13px",
        color: "#bfdbfe",
        opacity: 0,
        transform: "translateX(-4px)",
        transition: "all 200ms ease-out",
      },
      "&:hover::after": {
        opacity: 1,
        transform: "translateX(0)",
      },
    },
    cardIconWrap: {
      width: "36px",
      height: "36px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    cardText: {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "13.5px",
      fontWeight: 500,
      color: "#374151",
      lineHeight: 1.45,
      margin: 0,
    },
  };
});

var WelcomeScreen = function WelcomeScreen(_ref) {
  var onSendSuggestion = _ref.onSendSuggestion;
  var classes = useStyles();

  var userName = localStorage.getItem("Login_User_Name") || "there";

  return (
    <div className={classes.container}>
      <div className={classes.greeting}>
        {"Hello, "}
        <span className={classes.greetingName}>{userName}</span>
      </div>
      <div className={classes.subtitle}>
        Your financial data, on demand.
      </div>
      <div className={classes.suggestLabel}>Try asking</div>
      <div className={classes.grid}>
        {SUGGESTIONS.map(function (item, i) {
          var IconComponent = item.icon;
          return (
            <div
              key={i}
              className={classes.card}
              style={{ animationDelay: (250 + i * 80) + "ms" }}
              onClick={function () { onSendSuggestion(item.text); }}
              role="button"
              tabIndex={0}
              onKeyDown={function (e) {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSendSuggestion(item.text);
                }
              }}
            >
              <div
                className={classes.cardIconWrap}
                style={{ background: item.bgColor }}
              >
                <IconComponent style={{ fontSize: 18, color: item.color }} />
              </div>
              <p className={classes.cardText}>{item.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WelcomeScreen;
